import { defineAction } from '~/prix'
import { z } from 'zod'
import semenProgramFetchAction from './semenProgramFetch.action.json' with { type: 'json' }
import { semenProgramObject } from '../semenProgramObject'

const semenProgramFetchDefinition = defineAction({
  ...semenProgramFetchAction,

  input: z.object({ id: semenProgramObject.shape.id, includeDeleted: z.boolean().nullish() }),
  output: semenProgramObject,
})

export default semenProgramFetchDefinition
